import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import Box from "@mui/material/Box";
import QuoteBackup from "./QuoteBackupAndTransfer/QuoteBackup";
import QuoteDeletionReport from "../Components/QuoteCompare/QuoteDeletionReport";

const QuoteAdminAccess = () => {
  const [activeTab, setActiveTab] = useState("table1");
  const [role, setRole] = useState(sessionStorage.getItem("role") || "");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="app-container">
          <div style={{ padding: "5px", width: "95%" }}>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
              >
                {/* Backup Tab */}
                <Tab
                  label="BackUp Records"
                  value="table1"
                />

                {/* Deletion Tab with condition */}
                {role?.includes("report") && (
                  <Tab
                    label="Deletion Report"
                    value="table2"
                  />
                )}
              </Tabs>
            </Box>
            <div>
              {activeTab === "table1" && <QuoteBackup />}

              {activeTab === "table2" && role?.includes("report") && (
                <QuoteDeletionReport activeTab={activeTab} />
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteAdminAccess;